import { Link } from "react-router-dom";
import { ArrowRight, Phone, Sparkles } from "lucide-react";
import { CONTACT } from "@/lib/data";

const ServicesFinalCTA = () => (
  <section
    className="py-20 lg:py-28 bg-gradient-to-br from-cream via-sand to-cream relative overflow-hidden"
    data-testid="services-final-cta"
  >
    {/* Decorative orbs */}
    <div
      aria-hidden="true"
      className="absolute -top-32 -left-32 w-[500px] h-[500px] rounded-full pointer-events-none opacity-50"
      style={{
        background:
          "radial-gradient(circle, rgba(197,138,63,0.18) 0%, transparent 65%)",
      }}
    />
    <div
      aria-hidden="true"
      className="absolute -bottom-32 -right-32 w-[420px] h-[420px] rounded-full pointer-events-none opacity-50"
      style={{
        background:
          "radial-gradient(circle, rgba(122,154,130,0.16) 0%, transparent 65%)",
      }}
    />

    <div className="container-tm relative">
      <div className="max-w-3xl mx-auto text-center">
        <span className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-gold/15 text-gold mb-6">
          <Sparkles
            size={22}
            fill="currentColor"
            strokeWidth={0}
            className="text-gold"
          />
        </span>

        <p className="overline mb-4">Discutons de votre projet</p>

        <h2 className="font-serif font-light text-ink text-3xl md:text-5xl lg:text-6xl leading-[1.02] tracking-tight">
          Une étude gratuite,
          <br />
          <em className="text-gold">sous 24h</em>.
        </h2>

        <p className="mt-6 font-sans text-ink/65 text-base md:text-lg leading-relaxed max-w-2xl mx-auto">
          Dites-nous où se trouve votre bien, sa typologie et vos objectifs.
          Nous revenons vers vous sous 24h ouvrées avec une simulation chiffrée
          de revenus et un plan d'optimisation personnalisé. Sans engagement.
        </p>

        <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-center items-center">
          <Link
            to="/contact"
            data-testid="services-final-cta-contact"
            className="inline-flex items-center justify-center gap-2 bg-gold text-ink font-semibold px-8 py-4 rounded-full hover:bg-ink hover:text-gold transition-colors duration-300 text-sm shadow-soft"
          >
            Demander mon étude gratuite <ArrowRight size={15} />
          </Link>
          <a
            href={CONTACT.phoneHref}
            data-testid="services-final-cta-phone"
            className="inline-flex items-center justify-center gap-2 border border-ink/25 text-ink px-8 py-4 rounded-full hover:border-gold hover:text-gold transition-colors duration-300 text-sm"
          >
            <Phone size={14} strokeWidth={2} />
            {CONTACT.phone}
          </a>
        </div>

        {/* Trust signals */}
        <div className="mt-12 grid grid-cols-3 gap-3 max-w-xl mx-auto text-xs">
          {[
            "🔒 Aucun engagement",
            "📊 Simulation chiffrée",
            "⚡ Réponse sous 24h",
          ].map((t, i) => (
            <div
              key={i}
              data-testid={`services-trust-${i}`}
              className="bg-white/60 backdrop-blur-sm rounded-full py-2 px-3 text-ink/65 border border-ink/5"
            >
              {t}
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default ServicesFinalCTA;
